import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import Person from "@material-ui/icons/Person";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import adminNavbarLinksStyle from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.jsx";
import IconButton from '@material-ui/core/IconButton';
class HeaderLinks extends React.Component {
  
  state = {
    open: false,
    anchorEl: null
  };

  handleClick = (e) => {
    this.setState({ open: !this.state.open, anchorEl: e.currentTarget});
  };

  handleClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  logOut = () => {
    localStorage.clear();
    window.location.reload();
  }

  render() {
    const { classes, rtlActive } = this.props;
    
    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    });

    return (
      <div className={wrapper}>
        <NavLink to={`/admin/profile`}>
    
          <IconButton
            aria-label="more"
            aria-controls="person"
            aria-haspopup="true"
          >
            <Person />
          </IconButton>
        </NavLink>
         <IconButton
            aria-label="more"
            aria-controls="logout"
            aria-haspopup="true"
            onClick={this.logOut}
          >
              <ExitToAppIcon />
          </IconButton>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

export default withStyles(adminNavbarLinksStyle)(HeaderLinks);
